// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__uiR7C","inner":"Footer_inner__vwhC1","nextIcon":"Footer_nextIcon__2rywR","innerLeft":"Footer_innerLeft__1UzNB"};